import RandingStyle1 from "../../randing/RandingStyle1";
// import { Helmet } from "react-helmet";
import RandingStyle10 from "../../randing/RandingStyle10";

function Randing082({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/082/250124_01.jpg`}
      videoPath={`${process.env.REACT_APP_CDN_BASE}/images/082/250124_02.mp4`}
      qOptionColor="blue"
      formFieldColor="white"
      qTitleColor="#0001b4"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton3.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
    />
  );
}

export default Randing082;
